import { GET } from './executer';
import apiServiceInstance from './apiService';

export type RadarL2ExecutionStatus = 'succeeded' | 'failed' | 'skipped';

export interface RadarL2Execution {
  id: string;
  cloud_event_id: string;
  season_year: number | null;
  circuit_id: string | null;
  start_date: string | null;
  file_path: string;
  bucket: string;
  scan_timestamp: string | null;
  status: RadarL2ExecutionStatus;
  tile_uri: string | null;
  duration_ms: number;
  timings: string | null;
  error_message: string | null;
  executed_at: string;
}

export interface RadarL2ExecutionFilter {
  executed_after?: string;
  executed_before?: string;
}

export interface RadarL2LogEntry {
  timestamp: string;
  severity: string;
  message: string;
}

interface ExecutionsResponse {
  data: RadarL2Execution[];
  total: number;
  limit: number;
  offset: number;
}

class RadarL2IngestService {
  private async fetchBlob(url: string): Promise<Blob> {
    const token = apiServiceInstance.getToken();
    const response = await apiServiceInstance.client.client.get(url, {
      responseType: 'blob',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    if (response.data.type === 'application/json') {
      const text = await response.data.text();
      const err = JSON.parse(text) as { message?: string };
      throw new Error(err.message || 'Request failed');
    }

    return response.data;
  }

  async getExecutions(filter: RadarL2ExecutionFilter, limit = 100, offset = 0) {
    const params = new URLSearchParams();

    if (filter.executed_after) params.append('executed_after', filter.executed_after);
    if (filter.executed_before) params.append('executed_before', filter.executed_before);

    params.append('limit', String(limit));
    params.append('offset', String(offset));

    const url = `/api/radar-l2/executions?${params.toString()}`;

    return await apiServiceInstance.client.execute<ExecutionsResponse>(GET, url);
  }

  async getExecutionLogs(executionId: string) {
    const url = `/api/radar-l2/executions/${executionId}/logs`;

    return await apiServiceInstance.client.execute<RadarL2LogEntry[]>(GET, url);
  }

  async downloadExecutionH5(executionId: string) {
    return this.fetchBlob(`/api/radar-l2/executions/${executionId}/h5`);
  }

  async getExecutionPng(executionId: string) {
    return this.fetchBlob(`/api/radar-l2/executions/${executionId}/png`);
  }
}

const radarL2IngestService = new RadarL2IngestService();
export default radarL2IngestService;
